// extracted by mini-css-extract-plugin
module.exports = {"loadingContent":"AssessorAssessments_loadingContent__3L5Bd","container":"AssessorAssessments_container__3Yvxt"};